import { useEffect, useState } from 'react';
import './App.scss';
import './classes.scss';
import Header from './components/header/Header';
import request from './request';
import appSlice from './store/appSlice';
import store from './store/store';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Search from './components/search/Search';
import ThemeContext from './context/themeProvider';
import Results from './components/results/Results';
import NavigationMenu from './components/navigation-menu/NavigationMenu';
import NearbySearch from './components/nearby-search/NearbySearch';
import FavouritesPage from './components/favourites-page/FavouritesPage';

function App() {
  const [theme, setTheme] = useState(localStorage.theme || 'light');

  useEffect(() => {
    if (navigator.permissions?.query) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition((position) => {
            store.dispatch(appSlice.actions.updateGeolocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }));
          }, () => {

          });
        }
      }).catch(() => {});
    }

    request.get(`/`).then((response) => {
      let languageCode = 'en';
      let countryCode = response.data.metadata.country_code;

      if (response.data.metadata.country_code === 'GR') {
        languageCode = 'el';
      }

      store.dispatch(appSlice.actions.updateGeolocation({ languageCode, countryCode }));
      store.dispatch(appSlice.actions.updateCities(response.data.metadata.cities));
      store.dispatch(appSlice.actions.updateCategories(response.data.metadata.categories));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);
  
  return (
    <div className={`App ${theme}`}>
      <ThemeContext.Provider value={{ theme, setTheme }}>
        <BrowserRouter>
          <Header></Header>

          <main>
            <Routes>
              <Route exact path="/" element={<Search />}></Route>
              <Route path="/results/nearby/:coordinates" element={<Results />}></Route>
              <Route path="/results/:city/:category" element={<Results />}></Route>
              <Route path="/nearby" element={<NearbySearch />}></Route>
              <Route path="/favourites" element={<FavouritesPage />}></Route>
              <Route path="*" element={<Search />}></Route>
            </Routes>
          </main>

          <NavigationMenu></NavigationMenu>
        </BrowserRouter>
      </ThemeContext.Provider>
    </div>
  );
}

export default App;
